import { useAppDispatch } from "../../app/store/hooks";

import { formatToggled } from "./slice";

/**
 * Hook for handling time display style relative  or formatted time
 */
export const useOnClickHandler = () => {
    const dispatch = useAppDispatch();

    return () => {
        dispatch(formatToggled());
    };
};
